export const computeVatAmountFromRate = (
  percentRate: number,
  total: number,
) => {
  const rate = percentRate / 100;
  const amount = (rate * total) / (1 + rate);
  return parseFloat(amount.toFixed(2));
};
